import type { Filters } from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore.types'

export const DEFAULT_PLACE: NonNullable<Filters['place']> = {
  id: 0,
  name: 'Весь город',
  translit: 'default-item',
  isMetro: false,
}
